var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmployees(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7.5C15.3807 7.5 16.5 6.38071 16.5 5C16.5 3.61929 15.3807 2.5 14 2.5C12.6193 2.5 11.5 3.61929 11.5 5C11.5 6.38071 12.6193 7.5 14 7.5ZM14 8C15.6569 8 17 6.65685 17 5C17 3.34315 15.6569 2 14 2C12.3431 2 11 3.34315 11 5C11 6.65685 12.3431 8 14 8Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.40089 11.508C9.75395 10.3808 11.7538 9.65593 14 9.65593C16.076 9.65593 17.9429 10.2752 19.2827 11.2604C20.609 12.2356 21.3916 13.5446 21.4097 14.95H21.9497C21.9316 13.2763 21.002 11.8003 19.5785 10.7536C18.1387 9.69491 16.1656 9.05005 14 9.05005C11.6586 9.05005 9.5406 9.80405 8.07916 11.0216C6.85144 12.0443 6.06698 13.4147 6.05029 14.95H6.59034C6.60698 13.6602 7.26664 12.4529 8.40089 11.508Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.65593C11.7538 9.65593 9.75395 10.3808 8.40089 11.508C7.26664 12.4529 6.60698 13.6602 6.59034 14.95H6.05029C6.06698 13.4147 6.85144 12.0443 8.07916 11.0216C9.5406 9.80405 11.6586 9.05005 14 9.05005C16.1656 9.05005 18.1387 9.69491 19.5785 10.7536C21.002 11.8003 21.9316 13.2763 21.9497 14.95H21.4097C21.3916 13.5446 20.609 12.2356 19.2827 11.2604C17.9429 10.2752 16.076 9.65593 14 9.65593Z",
    fill: "#2D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 25.5C4.10457 25.5 5 24.6046 5 23.5C5 22.3954 4.10457 21.5 3 21.5C1.89543 21.5 1 22.3954 1 23.5C1 24.6046 1.89543 25.5 3 25.5ZM3 26C4.38071 26 5.5 24.8807 5.5 23.5C5.5 22.1193 4.38071 21 3 21C1.61929 21 0.5 22.1193 0.5 23.5C0.5 24.8807 1.61929 26 3 26Z",
    fill: "#2D2943"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 25.5C15.1046 25.5 16 24.6046 16 23.5C16 22.3954 15.1046 21.5 14 21.5C12.8954 21.5 12 22.3954 12 23.5C12 24.6046 12.8954 25.5 14 25.5ZM14 26C15.3807 26 16.5 24.8807 16.5 23.5C16.5 22.1193 15.3807 21 14 21C12.6193 21 11.5 22.1193 11.5 23.5C11.5 24.8807 12.6193 26 14 26Z",
    fill: "#2D2943"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 25.5C26.1046 25.5 27 24.6046 27 23.5C27 22.3954 26.1046 21.5 25 21.5C23.8954 21.5 23 22.3954 23 23.5C23 24.6046 23.8954 25.5 25 25.5ZM25 26C26.3807 26 27.5 24.8807 27.5 23.5C27.5 22.1193 26.3807 21 25 21C23.6193 21 22.5 22.1193 22.5 23.5C22.5 24.8807 23.6193 26 25 26Z",
    fill: "#2D2943"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 14.75H25.25V20H24.75V15.25H14.25V20H13.75V15.25H3.25V20H2.75V14.75Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.3dd05e50.svg";
export { ForwardRef as ReactComponent };